import type { Types } from '../types';
import type { BaseOptions } from '../../common/types';
import { omitEdgesAndInternalProperties, type SerializedEdgesOnlyVertexExport, type SerializedEdgesShape } from './util';
import type { SyllabusVertex } from '../interfaces/vertices/syllabuses';
import type { OutTypes } from './schedules';

export default (
  syllabuses: Types.Mixed.Syllabus[],
  options:     BaseOptions
): OutTypes.syllabus[] => {
  return syllabuses
    .map(x => {
      const edges: SerializedEdgesOnlyVertexExport<SyllabusVertex> = {
      } satisfies SerializedEdgesShape<SerializedEdgesOnlyVertexExport<SyllabusVertex>>;
      const nonEdges = omitEdgesAndInternalProperties(x, edges);

      return { ...nonEdges, ...edges };
    });
};
